import { Equipment } from './Equipment';
import { EquipmentDetails } from './EquipmentDetails';

export const EquipmentDetailsComponent = ({
  productDetailsData,
}: {
  productDetailsData: any;
}) => {
  return (
    <div className="w-full grid-cols-1">
      <Equipment productDetailsData={productDetailsData} />
      <EquipmentDetails />
    </div>
  );
};
